module.exports = __webpack_public_path__ + "static/quotes-1088f554a8c6175270cd7c5a473fdd0b.png";